import React, { Component, Fragment } from 'react'

const GoogleSignIn = (props) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: props.googleUrl }}></div>
    )
}

export default GoogleSignIn;